/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/TiffGenerator.yaml
import { ScanbotTiffGeneratorImpl } from './impl';
/**
 * Entry point for all TIFF generation features.
 */
export const ScanbotTiffGenerator = {
    /**
     * Creates a TIFF from the provided images with the specified configuration.
     * @param {ImageInput[]} params.images - The list of images to be used for creating the TIFF.
     * @param {TiffGeneratorParameters} params.tiffGeneratorParameters - The configuration parameters for TIFF generation.
     * @returns {Promise<string>} - The file uri pointing to the generated TIFF file.
     */
    async generateFromImages(params) {
        return ScanbotTiffGeneratorImpl.generateFromImages(params);
    },
    /**
     * Creates a TIFF from the provided images with the specified configuration.
     * @param {string} params.documentUuid - The Uuid of the document to be used for creating the TIFF.
     * @param {TiffGeneratorParameters} params.tiffGeneratorParameters - The configuration parameters for TIFF generation.
     * @returns {Promise<string>} - The file uri pointing to the generated TIFF file.
     */
    async generateFromDocument(params) {
        return ScanbotTiffGeneratorImpl.generateFromDocument(params);
    },
};
//# sourceMappingURL=TiffGenerator.js.map